// extracted by mini-css-extract-plugin
export default {"indicator":"createIndustryIndicator_indicator__pAt5H"};